<template>
    <div class="search-result">
        <!-- ============= 顶部背景图 ============= -->
        <!--div class="result-img" :style="'background: url(\'https://www.sinowealth.com/web/bk/'+name+'.png\');background-size: 100%;'">
          <!--img src="../../assets/images/toolsData/banner.png" style="height:505px;width: 1300px;margin: 0 auto;display: block;"-->
          <!-- img :src="'https://www.sinowealth.com/web/seach/'+img_name+'.png'" style="height: 505px;width: 1300px;margin: 0 auto;min-height:400px;display: block">
        </div-->

        <!-- ============= 表格栏 ============= -->
        <div class="search-result-detaile">
            <div class="detaile-box">
                <div>
                    <div class="detaile-title">{{type_name}}</div>
                    <div class="detaile-select">
                        <el-select v-model="selected" style="width: 360px" @change="change_tool">
                            <el-option 
                                    v-for="item in resourceList"
                                    :key="item.type_id"
                                    :label="item.type_name"
                                    :value="item.type_id"
                            ></el-option>
                        </el-select>
                        <el-input v-model="search"
                                  placeholder="输入关键字搜索"
                                  style="width: 360px;" @change="change_tool_inp"></el-input>
                        <el-button @click="getDevelopTools()" type="primary" style="width: 120px;">搜索</el-button>
                    </div>
                </div>
                <!-- ============= 相关工具 ============= -->
                <div class="detaile-table" v-if="pro_data!=''">
                    <!-- 表头 -->
                    <div class="table-title">产品资料</div>
                    <el-table
                        :data="pro_data"
                        class="table-content" :header-cell-style="{display:'none'}">
                        <el-table-column>
                            <template slot-scope="scope">
                                <router-link :to="{path: 'detaile', query: {pro_id: scope.row.pro_id}}" style="color: black">
                                <div>
                                    <span style='color:red;text-decoration:underline;padding-left: 20px;font-size: 22px;'>{{scope.row.pro_name}}</span>
                                </div>
                                <div class="pro_seach_div" v-if="scope.row.pro_basic" v-html="'描述：'+JSON.parse(scope.row.pro_basic_t).replace(new RegExp('<br>','g'),'&nbsp;&nbsp;&nbsp;')">
                                    
                                </div>
                                <div class="pro_seach_div" v-if="scope.row.pro_introduce" v-html="'特性：'+JSON.parse(scope.row.pro_introduce_t).replace(new RegExp('<br>','g'),'&nbsp;&nbsp;&nbsp;')">
                                    
                                </div>
                                <div class="pro_seach_div" v-else-if="scope.row.pro_introduce_2" v-html="'<span style=\'color:red\'>特性2：</span>'+JSON.parse(scope.row.pro_introduce_2_t).replace(new RegExp('<br>','g'),'&nbsp;&nbsp;&nbsp;')">
                                
                                </div>
                                </router-link>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <!-- ============= 开发工具表格 ============= -->
                <div class="detaile-table" :id=i v-for="(item,i) in developToolsList">
                    <!-- 表头 -->
                    <div class="table-title">{{i}}</div>
                    <el-table
                            :data="item"
                            class="table-content">
                        <el-table-column prop="tool_name" label="名称" align="center"></el-table-column>
                        <el-table-column prop="tool_num" label="文件编号" align="center"></el-table-column>
                        <el-table-column prop="tool_msg" label="说明" align="center" width="500px"></el-table-column>
                        <el-table-column prop="tool_type" label="类型" align="center" width="120px"></el-table-column>
                        <el-table-column prop="tool_edit" label="版本" align="center" width="100px"></el-table-column>
                        <el-table-column prop="tool_time" label="更新日期" align="center" width="100px"></el-table-column>
                        <el-table-column prop="download" label="下载" align="center" width="110px">
                            <!--template slot-scope="scope">
                                <img src="../../assets/images/toolsData/PDF.png"
                                     style="cursor: pointer"
                                     @click="donwnloadData">
                            </template-->
                            <template slot-scope="scope">
                              <!--el-button icon="iconfont icon-RAR" circle @click="downloadMarkOne(scope.row)"></el-button-->
                              <!--el-button type="primary" icon="iconfont icon-PDF1" @click="downloadMarkTwo(scope.row)"></el-button-->
                              <i v-if="scope.row.tool_new_name!='' && scope.row.tool_new_name!=null" style="font-size:38px;line-height:normal;cursor: pointer;" class="iconfont icon-RAR" @click="downloadMarkOne(scope.row)"></i>
                              <i v-if="scope.row.tool_new_pdf_name!='' && scope.row.tool_new_pdf_name!=null" style="font-size:38px;line-height:normal;cursor: pointer;" class="iconfont icon-PDF1" @click="downloadMarkTwo(scope.row)"></i>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="detaile-table" v-if="(developToolsList=='[]' || developToolsList=='') && (pro_data=='' || pro_data=='[]')">
                     无对应搜索条件信息，请更换关键字！
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/http/request'
    export default {
        data() {
            return {
                skillDataList: [],
                developToolsList: [],
                resourceList: [],
                type_name:'',
                selected:'',
                type_id:'',
                search:'',
                pro_data:'',
                img_name: {},//图片
                name: {},//图片
            }
        },
        mounted: function (){
            this.img_name='ban'+Math.floor(Math.random()*10+1);
            this.name='bk'+Math.floor(Math.random()*10+1);
            this.getSkillData();
            //获取GET的值
            this.type_id=this.get_get_val('type_id');
            this.search=this.get_get_val('search');
            this.getDevelopTools();
        },
        methods: {
            donwnloadData:function () {
                window.location.reload();
            },
            getSkillData: function () {
                api.http_mock('/api/getSkillData').then(res => {
                    console.log("tableDataTest---->", res);
                    this.skillDataList = res;
                })
            },
            getDevelopTools: function () {
                /*api.http_mock('/api/getDevelopTools').then(res => {
                    console.log("tableDataTest---->", res);
                    this.developToolsList = res;
                })*/
                let type_id=this.type_id;
                if(this.search){
                    type_id=type_id+"&search="+this.search;
                }
                this.$axios({
                        method:'get',
                        url:'/api/pre/json_go/tools?type_id='+type_id,
                    }).then((response) =>{          //这里使用了ES6的语法
                        this.developToolsList = response.data.data;
                        this.resourceList = response.data.type;
                        this.type_name=response.data.type_name;
                        this.pro_data=response.data.pro_data;
                        if(response.data.type_id){
                            this.selected=response.data.type_id*1;
                        }else{
                            this.selected=response.data.type_id;
                        }
                    }).catch((error) =>
                        console.log(error)       //请求失败返回的数据
                    )
            },
            // 下载
            downloadMarkOne: function (row) {
                location.href = '/api/pre/json_go/file_xz?tool_id='+row.tool_id+'&type=1'
            },
            downloadMarkTwo: function (row) {
                location.href = '/api/pre/json_go/file_xz?tool_id='+row.tool_id+'&type=2'
            },
            //选中异步
            change_tool: function (selVal) {
                this.type_id = selVal;
                this.getDevelopTools();
            },
            change_tool_inp: function (inpVal) {
                this.search = inpVal;
                this.getDevelopTools();
            },
            get_get_val:function (get_name){
                // 获取参数type_id的值
                var reg = new RegExp("(^|&)" + get_name + "=([^&]*)(&|$)");
                var r = window.location.search.substr(1).match(reg);
                if (r != null){
                    return decodeURI(r[2]);
                }else{
                    return '';
                }
            },
        },
    };
    
</script>

<style>
  .search-result {min-width: 1300px;}
  .search-result .result-img img{width: 100%;min-width: 1300px}
  .search-result .el-divider--horizontal {height: 1px;margin: 0;background: rgba(74,144,226,1);width: 1200px;}
  .search-result .search-result-table { height: 360px;display: inline-block  }
  .search-result .search-result-detaile { background-color: rgba(246,246,246,1);width: 100% }
  .search-result .search-result-detaile .detaile-box{ width: 1300px;margin: 0 auto; padding: 50px 0 ; }
  .detaile-box .detaile-table {margin-top: 40px;}
  .table-content .el-table__row .is-center {border-right: 1px solid #EBEEF5;padding: 5px 0;}
  .table-content .has-gutter div {font-size: 16px;}
  .detaile-box .detaile-title {background:url('../../assets/images/product/kuang.png') no-repeat; background-size:100% 64px;height:64px;font-size:48px;padding: 0 40px 0 20px;color:#ffffff;display: inline-block;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;max-width: 370px}
  .detaile-box .detaile-select {display: inline-block;float: right; line-height: 64px}
  .detaile-box .table-title { background-color:#eff5ff;width: 100%;line-height: 50px;text-align: center;font-size: 22px;font-weight: 500;border-bottom: 2px solid #4a90e2; }
  .detaile-box .product-info {width: 100%;background-color: #fff;}
  .detaile-box .product-info .product-data {margin:0 20px;color: #666666;line-height: 50px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
  .detaile-box .product-info .product-data  span {color: #000000;font-weight: 600;}
  .search-result .table-content { width:100%;}
  .pro_seach_div {width:90%; height:25px; line-height:25px; overflow:hidden;white-space: nowrap;text-overflow: ellipsis;float:left}
</style>



// WEBPACK FOOTER //
// src/pages/tools/seach.vue